import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderServiceService {
  public onHide$ = new EventEmitter<boolean>();
  constructor() { }
}
